import { create } from 'zustand';

import { OrganizationModel } from '../types';

interface OrganizationState {
    organizationData: OrganizationModel;
    loading: boolean;
    setOrganizationData: (data: OrganizationModel) => void;
    setLoading: (loading: boolean) => void;
}

export const useOrganizationState = create<OrganizationState>((set) => ({
  organizationData: {
    id: '',
    languages: [],
    hotel: '',
    city: '',
    associated_attractions: [],
    socialMediaSettings: {
      facebookUrl: '',
      instagramUrl: '',
      linkedInUrl: '',
      youTubeUrl: '',
    },
    virtual_tour_url: null,
    wifiSettings: { ssid: '', password: '', steps: [] },
    opinionServicesSettings: {},
    loyalty_program_url: null,
  },
  loading: true,
  setOrganizationData: (data: OrganizationModel) => set({ organizationData: data }),
  setLoading: (loading: boolean) => set({ loading }),
}));
